import React from 'react'
 import useSEO from "./useSEO";

const Opticonaccounting = () => {
  useSEO({ 
  title: "OPTICON Accounting Software | Advanced Business Accounting Solutions",
  description: "Manage accounting, taxation, inventory, and payroll seamlessly with OPTICON Accounting Software. Designed for efficiency, accuracy, and compliance for all business sizes.",
  keywords: "OPTICON accounting software, business accounting solutions, OPTICON GST software, OPTICON bookkeeping, OPTICON payroll, OPTICON financial reporting, accounting and inventory software, tax compliance software",
  ogTitle: "OPTICON Accounting Software - Smart Business Management",
  ogDescription: "Streamline accounting, GST, payroll, and reporting with OPTICON Accounting Software.",
  ogImage: "img/opticon-accounting.png",
  twitterTitle: "OPTICON Accounting Software - Smart Business Management",
  twitterDescription: "Powerful and reliable accounting software for modern business needs — OPTICON.",
  twitterImage: "img/opticon-accounting.png"
});

  return (
    <div>
      <>
  <section className="pt-lg-8 pt-xl-9">
    <div className="container position-relative pt-4 pt-lg-0">
      <div className="row align-items-center">
        {/* Title */}
        <div className="col-md-7 col-xl-6 mb-7 mb-md-0">
          <h1 className="mb-4"> OPTICON Accounting Software</h1>
          <p className="mb-4">
            OPTICON Accounting Software is a robust and user-friendly solution
            designed to simplify financial management for businesses of all
            sizes. With a focus on accuracy, compliance, and real-time control,
            OPTICON empowers organizations to manage their accounts, inventory,
            and taxation efficiently — all in one integrated platform.
          </p>
        </div>
        {/* Image */}
        <div className="col-md-5 ms-auto">
          <img
            src="img/opticon-accounting.png"
            alt="OPTICON Accounting Software"
          />
        </div>
      </div>
    </div>
  </section>
  <section className="overflow-hidden pb-0">
    <div className="container">
      <div className="row align-items-center">
        {/* Image */}
        <div className="col-lg-6 text-center position-relative mb-5 mb-lg-0">
          {/* Image */}
          <div className="pe-lg-6 pe-xl-8">
            <img
              src="img/opticon-accounting1.png"
              alt="OPTICON Accounting Software"
            />
          </div>
          {/* Decoration */}
        </div>
        {/* Content */}
        <div className="col-lg-6 ms-auto">
          {/* Title and content */}
          <h2 className="mb-lg-4"> Key Features:</h2>
          <hr className="my-4 my-lg-5" /> {/* Divider */}
          {/* List */}
          <div className="row">
            <div className="col-sm-12">
              <ul className="list-group list-group-borderless">
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b> End-to-End Accounting: </b>
                </li>
                <p>
                  Handle everything from general ledger, accounts
                  payable/receivable, to journal entries and reconciliations.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b>GST-Enabled: </b>
                </li>
                <p>
                  Generate GST-compliant invoices, automate return filing, and
                  manage tax reports seamlessly.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b>Inventory &amp; Billing Integration:</b>
                </li>
                <p>
                  {" "}
                  Track stock, automate billing, and manage purchase/sales
                  orders with ease.{" "}
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b> User Roles &amp; Permissions:</b>
                </li>
                <p>
                  {" "}
                  Maintain data security with multi-user access and role-based
                  permissions.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b>Financial Reporting:</b>
                </li>
                <p>
                  {" "}
                  Create real-time reports including balance sheets, P&amp;L
                  statements, trial balance, and tax summaries.
                </p>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b>Customizable Dashboard:</b>
                </li>
                <p>
                  {" "}
                  Access key financial insights and KPIs from a centralized,
                  easy-to-navigate interface.
                </p>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</>

    </div>
  )
}

export default Opticonaccounting
